<template>
  <div>
    <slot
      name="title"
      v-bind="{ class: titleClass, title }"
    >
      <template v-if="title">
        <PageContentHeading
          :class="titleClass"
        >
          {{ title }}
        </PageContentHeading>
      </template>
    </slot>
    <slot
      name="content"
      v-bind="{ class: [paragraphClass, $style.paragraph], paragraphs }"
    >
      <template v-if="paragraphs">
        <p
          v-for="paragraph in paragraphs"
          :key="paragraph"
          :class="[paragraphClass, $style.paragraph]"
        >
          {{ paragraph }}
        </p>
      </template>
    </slot>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import PageContentHeading from './PageContentHeading.ts.vue';
import { StyleClass } from '../types/StyleClass';

export interface Content {
  title?: string;
  paragraphs?: string[];
  titleClass?: StyleClass;
  paragraphClass?: StyleClass;
}

export default Vue.extend({
  components: {
    PageContentHeading,
  },
  props: {
    title: {
      type: String as PropType<Content['title']>,
      default: undefined,
    },
    paragraphs: {
      type: Array as PropType<Content['paragraphs']>,
      default: undefined,
    },
    titleClass: {
      type: [Object, String, Array] as PropType<StyleClass>,
      default: undefined,
    },
    paragraphClass: {
      type: [Object, String, Array] as PropType<StyleClass>,
      default: undefined,
    },
  },
});
</script>

<style module>
.paragraph:last-child {
  margin-bottom: 0;
}
</style>
